import axios from "axios";

export const LoginUser = (data) => async (onSuccess, onFail) => {
  const response = await axios.post("api/Authorization/Login", data);
  console.log(response)
  if(response.success)
    onSuccess(response.data);
  else onFail(response.message)
};
